import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CognitoState } from 'react-cognito';
import Color from 'color';
import debounce from 'lodash/debounce';
import groupBy from 'lodash/groupBy';
import times from 'lodash/times';
import values from 'lodash/values';
import { showSignup } from '../../actions/user';
import { setChosenPlan, getPlanPrice } from '../../actions/plan';
import { setRuntimeVariable } from '../../actions/runtime';
import { getLatestScenes } from '../../actions/search';
import { setColors } from '../../actions/ui';
import {
  EMPTY_ARRAY,
  EMPTY_OBJECT,
  MARKETING_NAV_LINKS,
  RESPONSIVE_SIZE,
  PLAN,
} from '../../constants';
import { imageColors, textColor, themeColors } from '../../lib/Color';
import { compose } from '../../lib/react';
import HeadlineAnimator from '../../components/HeadlineAnimator';
import Header from '../../components/Header';
import { withFooterDrawer } from '../../components/Footer';
import Section from '../../components/Section';
import Button from '../../components/Button';
import Link from '../../components/Link';
import Toggle from '../../components/Toggle';
import InstagramGrid from '../../components/InstagramGrid';
import PricingStrip from '../../components/PricingStrip';
import SceneCard from '../../components/SceneCard';
import SubscriptionPlans from '../../components/SubscriptionPlans';
import Style from '../../components/Style';
import {
  L1,
  L2,
  L3,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  P1,
  P2,
} from '../../components/Typography';

class Pricing extends React.PureComponent {
  static propTypes = {
    responsive: PropTypes.number,
    getLatestScenes: PropTypes.func,
    plan: PropTypes.object,
    layoutLoaded: PropTypes.bool,
    showSignup: PropTypes.func,
    onSelectPlan: PropTypes.func,
    onSetAnnual: PropTypes.func,
    loggedIn: PropTypes.bool,
    colors: PropTypes.object,
    updateColors: PropTypes.func,
    setMarketingVanityAnimation: PropTypes.func,
  };
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      baseColors: {
        dark: '#35211c',
        light: '#EFE1D4',
        highlight: '#AB5C47',
      },
      scenes: EMPTY_ARRAY,
    };

    props.updateColors(this.state.baseColors);
  }

  componentDidMount() {
    this.props
      .getLatestScenes(8)
      .then(scenes => this.setState({ scenes: scenes }));
  }

  render() {
    let headingPadding = '15rem 2rem 15rem';
    let seePlans = false;
    let justDoItWidth = 50;

    let sceneColumn = true;
    let sceneCardWidth = 250;
    let sceneCardMargin = 10;

    if (this.props.responsive >= RESPONSIVE_SIZE.PHONE) {
      seePlans = true;
    }
    if (this.props.responsive >= RESPONSIVE_SIZE.TABLET_PORTRAIT) {
      headingPadding = '22rem 2rem 30rem';
      justDoItWidth = 55;
      sceneCardWidth = 450;
      sceneColumn = false;
    }
    if (this.props.responsive >= RESPONSIVE_SIZE.TABLET_LANDSCAPE) {
      sceneCardWidth = 640;
    }
    if (this.props.responsive >= RESPONSIVE_SIZE.DESKTOP) {
    }

    const count = Math.max(
      Math.ceil(this.props.responsive / sceneCardWidth) + 1,
      1,
    );
    const bias = 100 / count;

    return (
      <div>
        <Section
          backgroundColor={Color(this.props.colors.light)
            .alpha(0.3)
            .string()}
          contentStyle={{ padding: headingPadding, textAlign: 'center' }}
        >
          <HeadlineAnimator
            show={this.props.layoutLoaded}
            onDone={this.props.setMarketingVanityAnimation}
            topContent={<H4>${getPlanPrice(PLAN.UNLIMITED, true)}/mo</H4>}
            middleContent={
              <div>
                <H2
                  style={{
                    margin: '2rem auto 0',
                    maxWidth: '48rem',
                    color: Style.Colors.shadow1,
                  }}
                >
                  Unlimited licenses.<br />Ridiculously affordable.
                </H2>
                <L3
                  style={{
                    display: 'block',
                    margin: '1.5rem auto 0',
                    color: Style.Colors.shadow3,
                  }}
                >
                  No Download Limit&nbsp;&nbsp;•&nbsp;&nbsp;1080p
                  +&nbsp;4K&nbsp;ProRes
                </L3>
              </div>
            }
            bottomContent={
              <div style={{ margin: '2.5rem auto 0' }}>
                <Button
                  onClick={this.props.showSignup}
                  size="large"
                  style={{ margin: '2rem 1rem' }}
                >
                  Get Started
                </Button>
                {seePlans && (
                  <L1 style={{ margin: '2rem 1rem', opacity: 0.75 }}>
                    <Link to="#plans">SEE PLANS</Link>
                  </L1>
                )}
              </div>
            }
          />
        </Section>

        <Section
          topAngle={14}
          backgroundColor={this.props.colors.highlight}
          style={{ position: 'relative' }}
        >
          <div
            style={{
              color: textColor(this.props.colors.highlight),
              textAlign: 'center',
              maxWidth: `${justDoItWidth}rem`,
              padding: '0 2rem',
              margin: 'calc(-12vw + 12rem) auto 10rem',
            }}
          >
            <H3 style={{ margin: '0.5em 0 1.5rem' }}>
              Start browsing.<br />You’ll love Storytape.
            </H3>
            <P1>
              We travel the world, shooting thousands of 4K clips every month.
              Then we organize it by scene to make crafting the
              perfect&nbsp;story&nbsp;simple.
            </P1>
          </div>

          {this.state.scenes.length > 0 && (
            <div style={{ position: 'relative', zIndex: 1 }}>
              {sceneColumn && (
                <div>
                  <SceneRow
                    allSenes={this.state.scenes}
                    count={1}
                    offset={0}
                    width={sceneCardWidth}
                    margin={sceneCardMargin}
                    cardStyle={{ width: '100%' }}
                  />
                  <SceneRow
                    allSenes={this.state.scenes}
                    count={1}
                    offset={1}
                    width={sceneCardWidth}
                    margin={sceneCardMargin}
                    cardStyle={{ width: '100%' }}
                    style={{
                      margin: `${sceneCardMargin / 10 * 2}rem 0`,
                    }}
                  />
                  <SceneRow
                    allSenes={this.state.scenes}
                    count={1}
                    offset={2}
                    width={sceneCardWidth}
                    margin={sceneCardMargin}
                    cardStyle={{ width: '100%' }}
                  />
                </div>
              )}
              {!sceneColumn && (
                <div>
                  <SceneRow
                    allSenes={this.state.scenes}
                    count={count}
                    offset={0}
                    width={sceneCardWidth}
                    margin={sceneCardMargin}
                    style={{ left: `-${sceneCardWidth * 0.033}rem` }}
                  />
                  <SceneRow
                    allSenes={this.state.scenes}
                    count={count}
                    offset={count}
                    width={sceneCardWidth}
                    margin={sceneCardMargin}
                    style={{
                      left: `-${sceneCardWidth * 0.066}rem`,
                      margin: `${sceneCardMargin / 10 * 2}rem 0`,
                    }}
                  />
                </div>
              )}

              <div
                style={{
                  margin: '6rem auto calc(-12vw + 12rem)',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Link to="/browse">
                  <Button baseColor={this.props.colors.light} arrow={true}>
                    Continue&nbsp;Browsing
                  </Button>
                </Link>
              </div>
            </div>
          )}

          <Section
            angle={14}
            backgroundColor={this.props.colors.light}
            style={{
              pointerEvents: 'none',
              position: 'absolute',
              zIndex: 0,
              top: '75%',
              bottom: 0,
            }}
            contentStyle={{
              height: '100%',
            }}
          />
        </Section>

        <Section
          topAngle={14}
          topMargin={0}
          backgroundColor={Style.Colors.white}
          contentStyle={{ padding: '6rem 3rem 10rem', textAlign: 'center' }}
        >
          <a id="plans" style={{ position: 'relative', top: '-10rem' }} />
          <H3 style={{ maxWidth: '16em', margin: 'auto' }}>
            A plan for every budget.
          </H3>
          <P1
            style={{ paddingTop: '1.5rem', maxWidth: '22em', margin: 'auto' }}
          >
            Upgrade, downgrade or cancel&nbsp;anytime.
          </P1>

          <div style={{ margin: '6rem auto 2rem' }}>
            <span
              style={{
                display: 'inline-block',
                minWidth: '12rem',
                textAlign: 'left',
              }}
            >
              Paying {this.props.plan.annual ? 'Annually' : 'Monthly'}
            </span>{' '}
            <Toggle
              checked={this.props.plan.annual}
              onToggle={this.props.onSetAnnual}
              style={{ display: 'inline-block' }}
            />
          </div>

          {/* TODO: Scale the plans when at desktop or larger resolutions. */}
          <div>
            <SubscriptionPlans
              plan={this.props.plan}
              onSelectPlan={this.props.onSelectPlan}
              bannerColor={this.props.colors.highlight}
            />
          </div>
        </Section>

        <Section>
          <PricingStrip />
        </Section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
    plan: state.plan.chosenPlan,
    loggedIn: state.cognito.state === CognitoState.LOGGED_IN,
    colors: state.ui.colors,
    layoutLoaded: state.runtime.layoutLoaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getLatestScenes: (min, max) => dispatch(getLatestScenes(min, max)),
    showSignup: () => dispatch(showSignup()),
    onSelectPlan: planName =>
      dispatch(setChosenPlan({ name: planName })).then(() =>
        setTimeout(dispatch, 1000, showSignup()),
      ),
    onSetAnnual: annual => dispatch(setChosenPlan({ annual: annual })),
    updateColors: colors => dispatch(setColors(colors)),
    setMarketingVanityAnimation: () =>
      dispatch(setRuntimeVariable('marketingVanityAnimation', true)),
  };
}

export default compose(
  withFooterDrawer(),
  connect(mapStateToProps, mapDispatchToProps),
)(Pricing);

function SceneRow({
  allSenes,
  count,
  offset,
  width,
  margin,
  style,
  cardStyle = EMPTY_OBJECT,
}) {
  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        ...style,
      }}
    >
      {times(count, index => {
        const sceneClips = allSenes[(index + offset) % allSenes.length];
        const anyClip = sceneClips[0];
        const colorsImage = imageColors(anyClip.scene_colors);
        const colorsTheme = themeColors(anyClip.scene_colors);
        return (
          <div
            key={`${index}_${anyClip.scene_id}`}
            style={{
              minWidth: `${width / 10}rem`,
              maxWidth: '95vw',
              margin: `0 ${margin / 10}rem`,
              ...cardStyle,
            }}
          >
            <Link to={`/browse/scene/${anyClip.scene_slug}`}>
              <SceneCard
                title={anyClip.scene_name}
                typeName={'Scene'}
                backgroundColor={colorsImage.dark}
                lqip={anyClip.scene_lqip}
                images={[anyClip.scene_thumbnail]}
                highlightColor={colorsTheme.highlight}
                allClips={sceneClips}
              />
            </Link>
          </div>
        );
      })}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/routes/pricing/Pricing.js